module.exports = __webpack_public_path__ + "img/restore-card1.10297cbe.svg";